import { createRouter, createWebHistory } from 'vue-router'

import VideoIntrosView from './pages/videoIntros';

const routes = [
  { path: '/video/intros', name: 'video-intros', component: VideoIntrosView },
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
